<div class="container">

  <div>
    <ng-container *ngIf="breadCrumb$ | async as breadCrumb">
      <bread-crumb [breadCrumb]="breadCrumb"></bread-crumb>
    </ng-container>

    <div class="row full-width">
      <div class="row-inner">
        <mat-form-field appearance="outline">
          <mat-label>Search clients</mat-label>
          <input [formControl]='searchText' matInput class="form-control">
        </mat-form-field>
      </div>
    </div>

    <h6 style="opacity: 0.6;">Please select a client to view more details. </h6>

    <div class="table-contianer">
      <table mat-table [dataSource]="dataSource" matSort class="full-width">
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef> <strong>Code</strong> </th>
          <td mat-cell *matCellDef="let element"> <strong><small>{{element.code}}</small></strong> </td>
        </ng-container>
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef> Title </th>
          <td mat-cell *matCellDef="let element"> {{element.title }} </td>
        </ng-container>
        <ng-container matColumnDef="level">
          <th mat-header-cell *matHeaderCellDef> Level </th>
          <td mat-cell *matCellDef="let element"> {{element.level}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="openItem(row)"></tr>

        <tr class="mat-row" *matNoDataRow [ngClass]="{hidden: loadingPageResults != false}">
          <td class="mat-cell text-center" colspan="999">No Results Found
          </td>
        </tr>
      </table>
      <ng-container *ngIf="loadingPageResults">
        <div class='table-loader'>
          <mat-spinner class='center'></mat-spinner>
        </div>
      </ng-container>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="dataResult?.collectionSize"></mat-paginator>
    </div>


  </div>
</div>